let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9p2N9")).then(() => parcelRequire('ldhE1'));